<template>
    <div>
        {{errorMessage}}
        <br/>
        <a href="/login">Try again</a>
    </div>
</template>
<script>
export default {
    computed: {
        errorMessage: function() {
            return this.$store.getters["errorMessage"];
        }
    }
}
</script>
<style scoped>

</style>